<div appModal mainClass="lg-modal" (closeModal)="close()" class="text-left">
  <div class="form-container">
    <section class="modal-title-container">
      <div class="modal--title">Upload a Highlight Reel</div>
      <div class="modal--subtitle">
        Drag and drop your file here and add your highlight reel info in the fields below
      </div>
    </section>

    <section class="modal-content-container">
      <div class="upload-container">
        <div
          class="thumbnail-container video-thumbnail-container flex justify-center items-center"
          [class.file-loaded]="file"
          [class.file-drag]="fileDrag"
          (drop)="onDrop($event)"
          (dragover)="onDragOver($event)"
          (dragleave)="onDragLeave($event)"
        >
          <ng-container *ngIf="!file && !uploading">
            <svg-icon src="/assets/images/svg/icons/misc/hr-upload.svg"></svg-icon>
            <p>
              <span class="mx-5"> .MOV </span>
              <span class="mx-5"> .MP4 </span>
              <span class="mx-5"> .MPEG </span>
            </p>
            <p class="text-gray text-base mb-20">Maximum file size is 500MB</p>
            <p class="text-gray text-base text-center">
              You can also attach by <br />
              <a (click)="videoUpload.click()">clicking here</a>
            </p>
          </ng-container>

          <ng-container *ngIf="file && !uploading">
            <svg-icon src="/assets/images/svg/icons/misc/hr-upload-active.svg"></svg-icon>
            <p class="text-center">
              {{ file?.name }}<br />
              <a class="text-base" (click)="resetFile()"> Remove file </a>
            </p>
          </ng-container>

          <ng-container *ngIf="uploading">
            <p class="text-progress">{{ uploadProgress }}%</p>

            <div class="progress-bar">
              <div [style.width.%]="uploadProgress"></div>
            </div>

            <p class="text--dark text-center">
              Your video is uploading.
              <br />
              Please Wait.
            </p>
          </ng-container>
        </div>

        <input
          type="file"
          accept="video/*"
          name="video-upload"
          id="video-upload"
          #videoUpload
          (change)="fileChanged($event)"
        />

        <div class="input-group__fields" [formGroup]="newHrForm">
          <label class="input-title required">Highlight reel title</label>
          <div class="input input-text" [class.input-error]="formHelpersService.isInputInvalid(newHrForm, 'title')">
            <input type="text" placeholder="Highlight reel title" formControlName="title" />
          </div>
        </div>
      </div>
    </section>

    <section class="modal-actions-container">
      <p class="text-sienna mt-10 mb-10" *ngIf="invalidFile">The selected file is invalid.</p>
      <button alt="Cancel" class="btn btn-lg btn-grey" (click)="close()">Cancel</button>
      <button
        alt="Add Video"
        class="btn btn-lg"
        [disabled]="!file || formHelpersService.isInputInvalid(newHrForm, 'title') || uploading"
        [class.btn-disabled]="!file || formHelpersService.isInputInvalid(newHrForm, 'title') || uploading"
        (click)="save()"
      >
        Add Video
      </button>
    </section>
  </div>
</div>
